import {isEqual} from "lodash";

// wersja formatu zapisanego widoku - podnieś przy zmianie i dopisz migrację w migrateConfig
export const TABLE_VIEW_CONFIG_VERSION = 1;

// limit backendu (settings-api) na rozmiar Config
export const MAX_CONFIG_BYTES = 100 * 1024;

export const MAX_CONFIG_NAME_LENGTH = 100;

// pola ustawień tabeli, które trafiają do zapisanego widoku (bez danych, ResultID i stanu rozwinięcia grup)
const VIEW_SETTINGS_KEYS = [
    "hidden",
    "order",
    "layout",
    "aggregates",
    "groupBy",
    // reguły poziomów grupowania ("Własne grupy") po columnKey - stare widoki ich nie mają (każda wartość)
    "groupRules",
    // kolejność grup poziomów "Każda wartość" po columnKey
    "groupSorts",
    // okres grupowania kolumn z datą po columnKey (brak - dzień)
    "groupDateUnits",
    "groupRowsLimit",
];

/**
 * Ustawienia widoku z ustawień tabeli - tylko pola widoku, bez pustych.
 * @param {Object} settings ustawienia AsyncTable (hidden, layout, aggregates, groupBy, ...)
 * @returns {Object}
 */
export function pickViewSettings(settings) {
    const result = {};
    for (const key of VIEW_SETTINGS_KEYS) {
        if (settings?.[key] !== undefined) result[key] = settings[key];
    }
    return result;
}

/**
 * Config zapisywany w settings-api. Backend go nie interpretuje - format należy do frontu.
 * @param {Object} settings ustawienia AsyncTable
 * @returns {{version: number, settings: Object}}
 */
export function buildConfig(settings) {
    return {
        version: TABLE_VIEW_CONFIG_VERSION,
        settings: pickViewSettings(settings),
    };
}

/**
 * Config z API -> aktualny format. Nieznana albo wyższa wersja zwraca null (widok nieobsługiwany),
 * zamiast wywracać tabelę.
 * @param {Object} config
 * @returns {{version: number, settings: Object}|null}
 */
export function migrateConfig(config) {
    if (!config || typeof config !== "object") return null;
    switch (config.version) {
        case 1:
            return {
                version: 1,
                settings: pickViewSettings(config.settings),
            };
        default:
            return null;
    }
}

/**
 * Czy bieżące ustawienia różnią się od zapisanego widoku (znacznik "zmieniony").
 * Bez aktywnego widoku porównujemy z domyślnymi (brak ustawień).
 */
export function isViewChanged(settings, activeConfig) {
    const current = pickViewSettings(settings);
    const saved = activeConfig
        ? (migrateConfig(activeConfig.Config)?.settings ?? {})
        : {};
    return !isEqual(current, saved);
}

/**
 * Walidacja przed wysłaniem (backend i tak zwróci 400).
 * @returns {{key: string, params?: Object}|null} klucz tłumaczenia błędu z parametrami albo null
 */
export function validateConfig(name, config) {
    const trimmed = (name ?? "").trim();
    if (trimmed.length === 0) return {key: "required"};
    if (trimmed.length > MAX_CONFIG_NAME_LENGTH) {
        return {
            key: "costsView.ocrRetry.maxLength",
            params: {limit: MAX_CONFIG_NAME_LENGTH},
        };
    }
    const bytes = new TextEncoder().encode(JSON.stringify(config)).length;
    if (bytes > MAX_CONFIG_BYTES) return {key: "tableViewTooBig"};
    return null;
}
